import React from 'react';
import { SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import { SearchRecommendationModule } from '../SearchRecommendation/SearchRecommendation.module';
import styles from './Pricing.module.scss';
export const PricingSection = _ref => {
  let pricing = _ref.pricing,
    tld = _ref.tld,
    domainName = _ref.domainName,
    _ref$useMobileLayout = _ref.useMobileLayout,
    useMobileLayout = _ref$useMobileLayout === void 0 ? false : _ref$useMobileLayout,
    _ref$denseStrikethrou = _ref.denseStrikethroughStyle,
    denseStrikethroughStyle = _ref$denseStrikethrou === void 0 ? false : _ref$denseStrikethrou,
    _ref$useIntroPriceLab = _ref.useIntroPriceLabelCopy,
    useIntroPriceLabelCopy = _ref$useIntroPriceLab === void 0 ? false : _ref$useIntroPriceLab,
    _ref$matchStrikethrou = _ref.matchStrikethroughSize,
    matchStrikethroughSize = _ref$matchStrikethrou === void 0 ? false : _ref$matchStrikethrou,
    _ref$isPricingLoading = _ref.isPricingLoading,
    isPricingLoading = _ref$isPricingLoading === void 0 ? false : _ref$isPricingLoading,
    _ref$exactMatch = _ref.exactMatch,
    exactMatch = _ref$exactMatch === void 0 ? false : _ref$exactMatch,
    _ref$compactPriceLabe = _ref.compactPriceLabel,
    compactPriceLabel = _ref$compactPriceLabe === void 0 ? false : _ref$compactPriceLabe;
  const _SearchRecommendation = SearchRecommendationModule.SDK.Layouts,
    PricingWrapper = _SearchRecommendation.PricingWrapper,
    PricingContent = _SearchRecommendation.PricingContent;
  if (!pricing || !pricing.price) {
    if (!isPricingLoading) {
      return null;
    }
    return /*#__PURE__*/React.createElement(SkeletonGroup, {
      skin: "light",
      className: useMobileLayout ? styles.mobileSkeletonGroup : styles.skeletonGroup
    }, /*#__PURE__*/React.createElement(PricingWrapper, {
      direction: "vertical",
      gap: useMobileLayout ? '4px' : 'SP1',
      align: useMobileLayout ? 'left' : 'right'
    }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
      className: styles.skeleton,
      width: useMobileLayout ? '139px' : '115px',
      height: useMobileLayout ? '20px' : '16px'
    }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
      className: styles.skeleton,
      width: useMobileLayout ? '139px' : '138px',
      height: useMobileLayout ? '20px' : '16px'
    })));
  }
  return /*#__PURE__*/React.createElement(PricingWrapper, {
    direction: "vertical",
    gap: "SP1",
    align: useMobileLayout ? 'left' : 'right'
  }, /*#__PURE__*/React.createElement(PricingContent, {
    pricing: pricing,
    tld: tld,
    domainName: domainName,
    denseStrikethroughStyle: denseStrikethroughStyle,
    useIntroPriceLabelCopy: useIntroPriceLabelCopy,
    matchStrikethroughSize: matchStrikethroughSize,
    exactMatch: exactMatch,
    compactPriceLabel: compactPriceLabel
  }));
};
//# sourceMappingURL=PricingSection.js.map